import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UserDetail } from '../../models/user-detail';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ModalComponent } from 'src/app/core/components/modal/modal.component';
import { UserService } from '../../services/user.service';
import { LoginService } from '../../services/login.service';
import { LoginUpdate } from '../../models/login-update.model';
import { UINotificationService } from 'src/app/core/services/ui-notification.service';
import { UserListRefresh } from '../../services/user-list.refresh';
import { NotificationType } from 'src/app/core/models/ui-notification.model';
import { EntityListRefresh } from 'src/app/core/services/entity-list.refresh';
import { TranslateService } from '@ngx-translate/core';
import { PasswordConfirmValidator } from '../../forms/user-form/password-confirm.validator';

@Component({
  selector: 'app-user-detail',
  templateUrl: './user-detail.component.html',
  styleUrls: ['./user-detail.component.css']
})
export class UserDetailComponent implements OnInit {

  form = new FormGroup({});
  user: UserDetail;
  selectedCompany: number;
  loginCompanies: any = [];
  menu = 'basic';

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private userService: UserService,
    private loginService: LoginService,
    private userListRefresh: EntityListRefresh,
    private uiNotificationService: UINotificationService,
    public translateService: TranslateService
  ) { }  

  ngOnInit() {
    this.user = this.route.snapshot.data.user;
    this.selectedCompany = +localStorage.getItem('selectedCompany');

    if (this.user.login.isSuperAdmin) {
      this.form.addControl('permission', new FormControl(String(2)));
    } else {
      const company = this.user.companies.filter(item => item.companyId === this.selectedCompany)[0];
      this.form.addControl('permission', new FormControl(String(company.permissionType)));
    }
    this.form.addControl('isActive', new FormControl(this.user.isActive));
    this.form.addControl('user', new FormGroup({
      name: new FormControl('', Validators.required),
      surname: new FormControl('', Validators.required),
      email: new FormControl('', [Validators.required, Validators.email]),
      phone: new FormControl('', Validators.required),
      password: new FormControl('', Validators.required),
      confirmPassword: new FormControl('', Validators.required)
    }, PasswordConfirmValidator.passwordMatch));

    this.form.patchValue({
      user: {
        name: this.user.name,
        surname: this.user.surname,
        email: this.user.login.email,
        phone: this.user.phone,
      }
    });
  }

  ngAfterViewInit() {
    if (this.user.isActive) {
      setTimeout(() => {
        this.form.get('user.password').setValidators(null);
        this.form.get('user.confirmPassword').setValidators(null);
        this.form.get('user.password').updateValueAndValidity();
        this.form.get('user.confirmPassword').updateValueAndValidity();
      });
    }
  }

  close(modal: ModalComponent) {
    modal.closeModal(null);
  }

  goToPermission() {
    this.router.navigate([{ outlets: { modal: ['user-lift-permission', this.user.id, this.user.login.id] } }]);
  }

  onSubmit(modal: ModalComponent) {
    if (this.form.valid) {
      this.userService.update({
        id: this.user.id,
        isActive: this.form.get('isActive').value,
        name: this.form.get('user.name').value,
        surname: this.form.get('user.surname').value,
        phone: this.form.get('user.phone').value
      }).subscribe(() => {
        let updateModel: LoginUpdate = {
          id: this.user.login.id,
          email: this.form.get('user.email').value,
          userId: this.user.id,
          companyId: this.selectedCompany,
          isSuperAdmin: this.user.login.isSuperAdmin,
          permissionType: +this.form.get('permission').value
        }

        if (this.form.get('user.password').value) {
          updateModel.password = this.form.get('user.password').value;
        }

        this.loginService.update(updateModel).subscribe(() => {
          this.onSuccessUpdate(modal);
        });
      });
    }
  }

  get isSuperadmin() {
    return this.loginService.isSuperadmin();
  }

  get isAdmin() {
    return this.loginService.isAdmin();
  }

  private onSuccessUpdate(modal: ModalComponent) {
    this.userListRefresh.refresh('user');
    this.uiNotificationService.add({
      type: NotificationType.Info,
      message: 'Uživatel byl aktualizován'
    });
    modal.closeModal(null);
  }

  onMenuChange(itemName: string) {
    if (itemName == 'basic') {
      return;
    }

    if (itemName == 'permission') {
      this.goToPermission();
    }
  }

}
